var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingBottomXs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    transform: "translate(196 98) rotate(180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.646 76.3536C103.842 76.5488 104.158 76.5488 104.354 76.3536L107.536 73.1716C107.731 72.9763 107.731 72.6597 107.536 72.4645C107.34 72.2692 107.024 72.2692 106.828 72.4645L104 75.2929L101.172 72.4645C100.976 72.2692 100.66 72.2692 100.464 72.4645C100.269 72.6597 100.269 72.9763 100.464 73.1716L103.646 76.3536ZM104.354 65.6464C104.158 65.4512 103.842 65.4512 103.646 65.6464L100.464 68.8284C100.269 69.0237 100.269 69.3403 100.464 69.5355C100.66 69.7308 100.976 69.7308 101.172 69.5355L104 66.7071L106.828 69.5355C107.024 69.7308 107.34 69.7308 107.536 69.5355C107.731 69.3403 107.731 69.0237 107.536 68.8284L104.354 65.6464ZM104.5 76L104.5 66L103.5 66L103.5 76L104.5 76Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 58L8 19C8 16.2386 10.2386 14 13 14L183 14C185.761 14 188 16.2386 188 19L188 58L8 58Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34715 17.0727C8.12271 17.6725 8 18.3219 8 19C8 18.3282 8.16358 17.6907 8.45685 17.1182L8.34715 17.0727ZM10.9753 14.1124L11.2531 14.7823C11.7969 14.5998 12.3855 14.5 13 14.5L15.0238 14.5L15.0238 13.5L13.5 13.5C13.3315 13.5 13.1647 13.5076 13 13.5224C12.2754 13.5877 11.5914 13.7935 10.9753 14.1124ZM19.0714 13.5L19.0714 14.5L23.119 14.5L23.119 13.5L19.0714 13.5ZM27.1667 13.5L27.1667 14.5L31.2143 14.5L31.2143 13.5L27.1667 13.5ZM35.2619 13.5L35.2619 14.5L39.3095 14.5L39.3095 13.5L35.2619 13.5ZM43.3571 13.5L43.3571 14.5L47.4048 14.5L47.4048 13.5L43.3571 13.5ZM51.4524 13.5L51.4524 14.5L55.5 14.5L55.5 13.5L51.4524 13.5ZM59.5476 13.5L59.5476 14.5L63.5952 14.5L63.5952 13.5L59.5476 13.5ZM67.6429 13.5L67.6429 14.5L71.6905 14.5L71.6905 13.5L67.6429 13.5ZM75.7381 13.5L75.7381 14.5L79.7857 14.5L79.7857 13.5L75.7381 13.5ZM83.8333 13.5L83.8333 14.5L87.8809 14.5L87.8809 13.5L83.8333 13.5ZM91.9286 13.5L91.9286 14.5L95.9762 14.5L95.9762 13.5L91.9286 13.5ZM100.024 13.5L100.024 14.5L104.071 14.5L104.071 13.5L100.024 13.5ZM108.119 13.5L108.119 14.5L112.167 14.5L112.167 13.5L108.119 13.5ZM116.214 13.5L116.214 14.5L120.262 14.5L120.262 13.5L116.214 13.5ZM124.31 13.5L124.31 14.5L128.357 14.5L128.357 13.5L124.31 13.5ZM132.405 13.5L132.405 14.5L136.452 14.5L136.452 13.5L132.405 13.5ZM140.5 13.5L140.5 14.5L144.548 14.5L144.548 13.5L140.5 13.5ZM148.595 13.5L148.595 14.5L152.643 14.5L152.643 13.5L148.595 13.5ZM156.691 13.5L156.691 14.5L160.738 14.5L160.738 13.5L156.691 13.5ZM164.786 13.5L164.786 14.5L168.833 14.5L168.833 13.5L164.786 13.5ZM172.881 13.5L172.881 14.5L176.929 14.5L176.929 13.5L172.881 13.5ZM180.976 13.5L180.976 14.5L183 14.5C183.614 14.5 184.203 14.5997 184.747 14.7823L185.025 14.1124C184.409 13.7935 183.725 13.5877 183 13.5224C182.835 13.5076 182.669 13.5 182.5 13.5L180.976 13.5ZM187.653 17.0727L187.543 17.1182C187.836 17.6907 188 18.3282 188 19C188 18.3219 187.877 17.6724 187.653 17.0727ZM8 57.5L8 58L8 58.5L9.95652 58.5L9.95652 57.5L8 57.5ZM13.8696 57.5L13.8696 58.5L17.7826 58.5L17.7826 57.5L13.8696 57.5ZM21.6957 57.5L21.6957 58.5L25.6087 58.5L25.6087 57.5L21.6957 57.5ZM29.5217 57.5L29.5217 58.5L33.4348 58.5L33.4348 57.5L29.5217 57.5ZM37.3478 57.5L37.3478 58.5L41.2609 58.5L41.2609 57.5L37.3478 57.5ZM45.1739 57.5L45.1739 58.5L49.087 58.5L49.087 57.5L45.1739 57.5ZM53 57.5L53 58.5L56.913 58.5L56.913 57.5L53 57.5ZM60.8261 57.5L60.8261 58.5L64.7391 58.5L64.7391 57.5L60.8261 57.5ZM68.6522 57.5L68.6522 58.5L72.5652 58.5L72.5652 57.5L68.6522 57.5ZM76.4783 57.5L76.4783 58.5L80.3913 58.5L80.3913 57.5L76.4783 57.5ZM84.3043 57.5L84.3043 58.5L88.2174 58.5L88.2174 57.5L84.3043 57.5ZM92.1304 57.5L92.1304 58.5L96.0435 58.5L96.0435 57.5L92.1304 57.5ZM99.9565 57.5L99.9565 58.5L103.87 58.5L103.87 57.5L99.9565 57.5ZM107.783 57.5L107.783 58.5L111.696 58.5L111.696 57.5L107.783 57.5ZM115.609 57.5L115.609 58.5L119.522 58.5L119.522 57.5L115.609 57.5ZM123.435 57.5L123.435 58.5L127.348 58.5L127.348 57.5L123.435 57.5ZM131.261 57.5L131.261 58.5L135.174 58.5L135.174 57.5L131.261 57.5ZM139.087 57.5L139.087 58.5L143 58.5L143 57.5L139.087 57.5ZM146.913 57.5L146.913 58.5L150.826 58.5L150.826 57.5L146.913 57.5ZM154.739 57.5L154.739 58.5L158.652 58.5L158.652 57.5L154.739 57.5ZM162.565 57.5L162.565 58.5L166.478 58.5L166.478 57.5L162.565 57.5ZM170.391 57.5L170.391 58.5L174.304 58.5L174.304 57.5L170.391 57.5ZM178.217 57.5L178.217 58.5L182.13 58.5L182.13 57.5L178.217 57.5ZM186.043 57.5L186.043 58.5L188 58.5L188 58L188 57.5L186.043 57.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white",
    transform: "translate(196 98) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingBottomXs);
export default __webpack_public_path__ + "static/media/padding_bottom_xs.08b7fb1756f518b8e7d2a24b53311010.svg";
export { ForwardRef as ReactComponent };